import { FC, useEffect, useState } from "react";
import * as cheerio from "cheerio";

import { useStyles } from "./styles";

interface Preview {
  title: string;
  url: string;
  description: string | null;
  image: string | null;
}

function findURLs(text: string): string[] | null {
  const urlRegex =
    /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|])/gi;
  return text.match(urlRegex);
}

async function fetchURLPreview(url: string): Promise<Preview | null> {
  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const html = await response.text();
    const $ = cheerio.load(html);
    const title = $("title").text();
    const description = $('meta[name="description"]').attr("content") || null;
    const image = $('meta[property="og:image"]').attr("content") || null;
    return { title, url, description, image };
  } catch (error) {
    return null;
  }
}

interface URLPreviewProps {
  commentText: string;
}

const URLPreview: FC<URLPreviewProps> = ({ commentText }) => {
  const { classes } = useStyles();

  const [preview, setPreview] = useState<Preview | null>(null);

  useEffect(() => {
    const urls = findURLs(commentText);
    if (urls) {
      urls.forEach((url) => {
        // Replace `fetchURLPreview` with your actual API call to the backend
        fetchURLPreview(url).then((preview) => {
          setPreview(preview);
        });
      });
    }
  }, [commentText]);

  return (
    <>
      {preview && (
        <div className={classes.previewContainer}>
          <a
            href={preview.url}
            target="_blank"
            rel="noopener noreferrer"
            className={classes.previewTitleLink}
          >
            <div className={classes.previewTitle}>{preview.title}</div>
          </a>
          {preview.description && (
            <div className={classes.previewDescription}>
              {preview.description}
            </div>
          )}
          {preview.image && (
            <a href={preview.url} target="_blank" rel="noopener noreferrer">
              <img
                src={preview.image}
                alt="Preview"
                className={classes.previewImage}
              />
            </a>
          )}
        </div>
      )}
    </>
  );
};

export default URLPreview;
